import { useDispatch } from 'react-redux';
import { combineReducers } from 'redux';
import auth from './auth';
import requiredOnboarding from './requiredOnboarding';
import requests from './Requests';
import abstractedProducts from './Products';
import promotions from './Promotions';
import config from './Config';
import customerCurrencyCode from './CustomerCurrencyCode';
import activeCurrencyCode from './ActiveCurrencyCode';
import retail from './Retail';
import numContactsInCrm from './NumContactsInCrm';
import marketingContacts from './MarketingContacts';
import settings from './Settings';
import phoneNumbers from './PhoneNumbers';
import queryParamTerm from './QueryParamTerm';
import purchaseMotionsByLocation from './PurchaseMotionsByLocation';
import publicFeatureFlags from './PublicFeatureFlags';
import productInventory from './ProductInventory';
import country from './Country';
import features from './Features';
import compare from './Compare';
import businessObjectives from './BusinessObjectives';
import { useSelector } from 'react-redux';
export const rootReducer = combineReducers({
  auth,
  requiredOnboarding,
  requests,
  abstractedProducts,
  promotions,
  config,
  customerCurrencyCode,
  activeCurrencyCode,
  retail,
  numContactsInCrm,
  marketingContacts,
  phoneNumbers,
  settings,
  purchaseMotionsByLocation,
  queryParamTerm,
  publicFeatureFlags,
  country,
  productInventory,
  features,
  compare,
  businessObjectives
}); // This type represents the state of your root reducer,
// and can be useful when creating selectors

// Should be used in place of useDispatch throughout the application
export function useAppDispatch() {
  return useDispatch();
}
export const useAppSelector = useSelector;